module.exports = __webpack_public_path__ + "ac78bde499c1942c0d87d0fe1c91c051.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/favorite/thaoduoc.jpg
// module id = ./assets/images/favorite/thaoduoc.jpg
// module chunks = 0